import React, { Component } from 'react';

class Button extends Component {
  render() {

    const props = this.props,
      css = [ 'btn' ];
    
    if( props.theme )
      css.push('btn_'+props.theme)

    if( props.class )
      css.push(props.class);

    const settings = {
      className: css.join(' '),
      disabled: props.disabled,
      onClick: props.handleClick
    };
    
    return (
      <button {...settings}>
        { this.props.children }
      </button>
    );
  }
}
export default Button;